import { OrderStatus } from '../../enums';
import { MarinaOrder } from '../../marina-order';
import { OrderItem } from '../../order-item';
import { OrderQuota } from '../../order-quota';
import { OrderItemToDetachedInput } from './OrderItemToDetachedInput';
import { OrderQuotaToDetachedInput } from './OrderQuotaToDetachedInput';

export class MarinaOrderDetachedInput {
  value: number;
  orderStatus: OrderStatus;
  orderDate: Date;
  orderObs: string;
  customerId: number;
  orderQuotas: OrderQuotaToDetachedInput[];
  boatId: number;
  marinaId: number;
  orderItems: OrderItemToDetachedInput[];
  origin: string;
  serviceBoatId: number;
  serviceCustomerId: number;
  dateTuition: Date;
  orderNumber: number;
  cashDown: number;
  workshopBudgetId: number;
  updateAt: string;
  lastEmployeeName: string;

  constructor(order:MarinaOrder) {

    this.orderQuotas = [];
    this.value = 0;
    this.orderStatus = order.orderStatus;
    this.orderDate = order.orderDate ? new Date(order.orderDate) : new Date();
    this.orderObs = order.orderObs || '';
    this.customerId = order.customer.id || 0;
    this.boatId = null;
    this.marinaId = null;
    this.origin = order.origin || '';
    this.serviceBoatId = null;
    this.serviceCustomerId = null;
    this.dateTuition = null;
    this.orderNumber = null;
    this.cashDown = 0;
    this.workshopBudgetId = null;
    this.updateAt = '';
    this.lastEmployeeName = '';

    if (order.orderItems) {
      this.orderItems = order.orderItems.map((item) => {
        const orderItemInput = new OrderItemToDetachedInput();
        orderItemInput.id = item.id;
        orderItemInput.qtyRequested = item.qtyRequested;
        orderItemInput.qtySupplied = item.qtySupplied;
        orderItemInput.itemValue = item.itemValue;
        orderItemInput.itemStatus = true;
        orderItemInput.itemObs = item.itemObs;
        orderItemInput.dateSupply = item.dateSupply ? new Date(item.dateSupply) : null;
        orderItemInput.marinaOrderId = null;
        orderItemInput.fuelTankFraction = item.fuelTankFraction;
        orderItemInput.fuelMeasurementType = item.fuelMeasurementType;
        orderItemInput.productId = item.product ? item.product.id : null;
        orderItemInput.itemTotal = item.totalValue || 0;
        orderItemInput.discount = item.discount || 0;
        orderItemInput.dateReference = item.dateReference || null;
        orderItemInput.duedateDiscount = item.duedateDiscount || 0;
        orderItemInput.workshopBudgetItemId = null;

        return orderItemInput;
      });
    } else {
      this.orderItems = [];
    }
    if (order.orderQuotas==null || order.orderQuotas.length === 0) {
      const orderQuota = new OrderQuotaToDetachedInput();
      orderQuota.id = null;
      orderQuota.quota = 100;
      orderQuota.customerId = this.customerId;
      orderQuota.orderId = null;
      this.orderQuotas.push(orderQuota);
    }else {}



  }
}
